import { PenTool } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const AgentSkillIcon = DeckardIconWrapper({ Icon: PenTool });
